/**
 * Author: Harsh Agrawal
 * Summary: The not-eligible page. Dynamically shows an ineligibility message (from navigation state)
 * and an "Upgrade My Plan" CTA. Thin wrapper over the shared CheckoutMessage layout.
 *
 * The fallbacks below are only reached on direct navigation — normally the backend's EligibleResponse
 * supplies message/description through navigation state, already localized server-side. They are
 * resolved from the UI catalog (public/translation/{locale}/internal/UIMessages.csv) using the same
 * useSelector(getTranslation) + t_message pattern as the rest of the checkout pages, so a customer
 * landing here without state does not see an empty page in their own locale.
 */

import React from 'react'
import { useSelector } from 'react-redux'
import CheckoutMessage from '../../../components/checkoutMessage'
import { getTranslation } from '../../../reducers/translation'
import { TRANSLATION_TYPE } from '../../../utils/constants'

function NotEligible() {
    const t = useSelector(getTranslation)
    const t_message = t[TRANSLATION_TYPE.MESSAGE] ?? {}

    return (
        <CheckoutMessage
            showUpgradeCta
            fallbackMessage={
                t_message?.['checkout.message.not_eligible']
                ?? "This purchase isn't available for your account"
            }
            fallbackDescription={
                t_message?.['checkout.message.not_eligible_description']
                ?? 'Your current plan does not support this change. Upgrading your plan may make it available.'
            }
        />
    )
}

export default NotEligible
